import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { TermsOfUseContainerComponent } from './terms-of-use.container';
import { SharedModule } from '../../shared/shared.module';

import { IconModule } from 'atlas-icon';

export const COMPONENTS = [
  TermsOfUseContainerComponent
];

@NgModule({
  declarations: COMPONENTS,
  imports: [
    CommonModule,
    SharedModule,
    IconModule
  ],
  exports: COMPONENTS,
  providers: [],
  bootstrap: [],
})
export class TermsOfUseModule {
}
